// components/HelpModal/ShortcutsTab.jsx
import React, { useState } from "react";
import "./ShortcutsTab.css";

const ShortcutsTab = () => {
  const [hoveredKey, setHoveredKey] = useState(null);

  const shortcuts = [
    { keys: ["Space"], description: "شروع / توقف پخش", category: "پخش" },
    { keys: ["F", "Enter"], description: "تمام صفحه", category: "نمایش" },
    { keys: ["M"], description: "قطع / وصل صدا", category: "صدا" },
    { keys: ["↑", "↓"], description: "افزایش / کاهش صدا", category: "صدا" },
    { keys: ["→", "←"], description: "۵ ثانیه جلو / عقب", category: "پخش" },
    {
      keys: ["T"],
      description: "نمایش / مخفی کردن زیرنویس ۱",
      category: "زیرنویس",
    },
    {
      keys: ["Y"],
      description: "نمایش / مخفی کردن زیرنویس ۲",
      category: "زیرنویس",
    },
    {
      keys: ["Q", "W"],
      description: "افزایش / کاهش سایز زیرنویس ۱",
      category: "زیرنویس",
    },
    {
      keys: ["E", "R"],
      description: "افزایش / کاهش سایز زیرنویس ۲",
      category: "زیرنویس",
    },
    { keys: ["A"], description: "رفتن به زیرنویس قبلی", category: "زیرنویس" },
    { keys: ["D"], description: "رفتن به زیرنویس بعدی", category: "زیرنویس" },
    { keys: ["S"], description: "تکرار زیرنویس فعلی", category: "زیرنویس" },
    {
      keys: ["Shift", "S"],
      description: "تکرار بی‌نهایت زیرنویس فعلی",
      category: "زیرنویس",
      isCombination: true,
    },
    { keys: ["["], description: "کاهش تاخیر زیرنویس ۱", category: "زیرنویس" },
    { keys: ["]"], description: "افزایش تاخیر زیرنویس ۱", category: "زیرنویس" },
    {
      keys: ["Shift", "["],
      description: "کاهش تاخیر زیرنویس ۲",
      category: "زیرنویس",
      isCombination: true,
    },
    {
      keys: ["Shift", "]"],
      description: "افزایش تاخیر زیرنویس ۲",
      category: "زیرنویس",
      isCombination: true,
    },
    {
      keys: ["Shift", "+"],
      description: "افزایش سرعت پخش",
      category: "پخش",
      isCombination: true,
    },
    {
      keys: ["Shift", "-"],
      description: "کاهش سرعت پخش",
      category: "پخش",
      isCombination: true,
    },
    {
      keys: ["Shift", "*"],
      description: "ریست سرعت به ۱x",
      category: "پخش",
      isCombination: true,
    },
    {
      keys: ["C"],
      description: "باز کردن تنظیمات زیرنویس",
      category: "زیرنویس",
    },
    { keys: ["H"], description: "باز کردن راهنما", category: "عمومی" },
    { keys: ["Esc"], description: "بستن مودال‌ها", category: "عمومی" },
  ];

  const categoryOrder = ["زیرنویس", "پخش", "نمایش", "صدا", "عمومی"];
  const categories = categoryOrder.filter((cat) =>
    shortcuts.some((s) => s.category === cat)
  );

  return (
    <div className="shortcuts-tab">
      {/* لیست کامل شورتکات‌ها - اول */}
      <div className="shortcuts-list">
        <h3>
          <i className="fas fa-list"></i>
          لیست کامل کلیدهای میانبر
        </h3>

        {categories.map((category) => (
          <div key={category} className="shortcut-category">
            <div className="category-title">{category}</div>
            <div className="shortcut-items">
              {shortcuts
                .filter((s) => s.category === category)
                .map((shortcut, index) => (
                  <div key={index} className="shortcut-item">
                    <div className="shortcut-key">
                      {shortcut.keys.map((key, i) => (
                        <React.Fragment key={i}>
                          <span className="key-badge">{key}</span>
                          {i < shortcut.keys.length - 1 && (
                            <span className="key-separator">
                              {shortcut.isCombination ? "+" : "/"}
                            </span>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                    <div className="shortcut-desc">{shortcut.description}</div>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>

      {/* کیبورد تعاملی - آخر */}
      <div className="keyboard-container">
        <h3>
          <i className="fas fa-keyboard"></i>
          کیبورد تعاملی (ماوس را روی کلیدها ببرید)
        </h3>

        <div className="keyboard">
          {/* ردیف اول: اعداد */}
          <div className="keyboard-row">
            {[
              "`",
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "0",
              "-",
              "=",
              "Backspace",
            ].map((key) => (
              <div
                key={key}
                className={`key special-key ${
                  hoveredKey === key ? "hovered" : ""
                }`}
              >
                {key}
              </div>
            ))}
          </div>

          {/* ردیف دوم: QWERTYUIOP */}
          <div className="keyboard-row">
            <div className="key tab-key">Tab</div>
            {["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"].map((key) => (
              <div
                key={key}
                className={`key ${hoveredKey === key ? "hovered" : ""}`}
                onMouseEnter={() => setHoveredKey(key)}
                onMouseLeave={() => setHoveredKey(null)}
              >
                {key}
              </div>
            ))}
            <div className="key special-key">[{"]"}</div>
            <div className="key special-key">\\</div>
          </div>

          {/* ردیف سوم: ASDFGHJKL */}
          <div className="keyboard-row">
            <div className="key caps-key">Caps</div>
            {["A", "S", "D", "F", "G", "H", "J", "K", "L"].map((key) => (
              <div
                key={key}
                className={`key ${hoveredKey === key ? "hovered" : ""}`}
                onMouseEnter={() => setHoveredKey(key)}
                onMouseLeave={() => setHoveredKey(null)}
              >
                {key}
              </div>
            ))}
            <div className="key special-key">;</div>
            <div className="key special-key">'</div>
            <div
              className="key enter-key"
              onMouseEnter={() => setHoveredKey("Enter")}
              onMouseLeave={() => setHoveredKey(null)}
            >
              Enter
            </div>
          </div>

          {/* ردیف چهارم: ZXCVBNM */}
          <div className="keyboard-row">
            <div className="key shift-key">Shift</div>
            {["Z", "X", "C", "V", "B", "N", "M"].map((key) => (
              <div
                key={key}
                className={`key ${hoveredKey === key ? "hovered" : ""}`}
                onMouseEnter={() => setHoveredKey(key)}
                onMouseLeave={() => setHoveredKey(null)}
              >
                {key}
              </div>
            ))}
            <div className="key special-key">,</div>
            <div className="key special-key">.</div>
            <div className="key special-key">/</div>
            <div className="key shift-key">Shift</div>
          </div>

          {/* ردیف پنجم: Space, Arrow Keys */}
          <div className="keyboard-row bottom-row">
            <div className="key ctrl-key">Ctrl</div>
            <div className="key win-key">Win</div>
            <div className="key alt-key">Alt</div>
            <div
              className="key space-key"
              onMouseEnter={() => setHoveredKey("Space")}
              onMouseLeave={() => setHoveredKey(null)}
            >
              Space
            </div>
            <div className="key alt-key">Alt</div>
            <div className="key arrow-keys">
              <div
                className="arrow-up"
                onMouseEnter={() => setHoveredKey("↑")}
                onMouseLeave={() => setHoveredKey(null)}
              >
                ↑
              </div>
              <div
                className="arrow-down"
                onMouseEnter={() => setHoveredKey("↓")}
                onMouseLeave={() => setHoveredKey(null)}
              >
                ↓
              </div>
              <div
                className="arrow-left"
                onMouseEnter={() => setHoveredKey("←")}
                onMouseLeave={() => setHoveredKey(null)}
              >
                ←
              </div>
              <div
                className="arrow-right"
                onMouseEnter={() => setHoveredKey("→")}
                onMouseLeave={() => setHoveredKey(null)}
              >
                →
              </div>
            </div>
          </div>
        </div>

        {/* کادر توضیحات - همیشه ثابت */}
        <div className="key-hover-info">
          {hoveredKey
            ? hoveredKey === "A"
              ? "🔹 رفتن به زیرنویس قبلی"
              : hoveredKey === "S"
              ? "🔹 تکرار زیرنویس فعلی (با Shift: تکرار بی‌نهایت)"
              : hoveredKey === "D"
              ? "🔹 رفتن به زیرنویس بعدی"
              : hoveredKey === "F"
              ? "🔹 تمام صفحه"
              : hoveredKey === "M"
              ? "🔹 قطع / وصل صدا"
              : hoveredKey === "T"
              ? "🔹 نمایش / مخفی کردن زیرنویس ۱"
              : hoveredKey === "Y"
              ? "🔹 نمایش / مخفی کردن زیرنویس ۲"
              : hoveredKey === "Q"
              ? "🔹 افزایش سایز زیرنویس ۱"
              : hoveredKey === "W"
              ? "🔹 کاهش سایز زیرنویس ۱"
              : hoveredKey === "E"
              ? "🔹 افزایش سایز زیرنویس ۲"
              : hoveredKey === "R"
              ? "🔹 کاهش سایز زیرنویس ۲"
              : hoveredKey === "C"
              ? "🔹 باز کردن تنظیمات زیرنویس"
              : hoveredKey === "H"
              ? "🔹 باز کردن راهنما"
              : hoveredKey === "Space"
              ? "🔹 شروع / توقف پخش"
              : hoveredKey === "Enter"
              ? "🔹 تمام صفحه"
              : hoveredKey === "Esc"
              ? "🔹 بستن مودال‌ها"
              : hoveredKey === "↑"
              ? "🔹 افزایش صدا"
              : hoveredKey === "↓"
              ? "🔹 کاهش صدا"
              : hoveredKey === "←"
              ? "🔹 ۵ ثانیه به عقب"
              : hoveredKey === "→"
              ? "🔹 ۵ ثانیه به جلو"
              : "⚠️ برای این کلید عملکردی تعریف نشده است"
            : "💡 برای دیدن عملکرد هر کلید، ماوس را روی آن ببرید"}
        </div>
      </div>
    </div>
  );
};

export default ShortcutsTab;
